import { Component, Input } from '@angular/core';
import { faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-request-detail',
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss'],
})
export class RequestDetailComponent {
  @Input() dataSource: any;
  faXmark = faXmark;
  faCheck = faCheck;
  displayedColumnsRequest: string[] = [
    'status',
    'date',
    'action',
    'userEmail',
    'comment',
  ];
}
